import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export default function NotFound() {
  const location = useLocation();

  useDocumentTitle({
    title: '页面不存在 - 91黑料网',
    description: '你访问的页面不存在，返回91黑料网首页查看最新黑料资讯与热门爆料。',
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="mx-auto flex max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <p className="font-label text-7xl font-bold text-primary-500 md:text-9xl">404</p>
        <h1 className="mt-4 text-xl font-black text-foreground-950 md:text-2xl">
          页面走丢了
        </h1>
        <p className="mt-2 max-w-md text-sm text-foreground-500">
          你要找的页面不存在或已被移除。当前访问路径：
          <span className="ml-1 font-mono text-foreground-700">{location.pathname}</span>
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/hot"
            className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            查看热门排行
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}